import { PropertyType } from 'esa-ui-library/lib/types';
import { isEmpty } from 'lodash';

export const getErrorMessage = (field: string): string => `${field} is required`;

export const validateForm = (form: PropertyType): PropertyType | null => {
	const errors: PropertyType = {};

	if (!form.campaign_name) {
		errors.campaign_name = getErrorMessage('Campaign name');
	}

	if (!form.campaign_description) {
		errors.campaign_description = getErrorMessage('Campaign description');
	}

	if (!form.status || (Array.isArray(form.status) && form.status.length === 0)) {
		errors.status = getErrorMessage('Status');
	}

	if (!form.partners || (Array.isArray(form.partners) && form.partners.length === 0)) {
		errors.partners = getErrorMessage('Partners');
	}

	if (!form.from_date) {
		errors.from_date = getErrorMessage('Start date');
	}
	if (!form.to_date) {
		errors.to_date = getErrorMessage('End date');
	}

	if (!form.device || (Array.isArray(form.device) && form.device.length === 0)) {
		errors.device = getErrorMessage('Device');
	}

	if (!form.free_spin_total_value) {
		errors.free_spin_total_value = getErrorMessage('Free spin total');
	} else if (isNaN(+form.free_spin_total_value)) {
		errors.free_spin_total_value = 'Free spin total must be a number';
	}

	if (!form.free_spin_bet_value) {
		errors.free_spin_bet_value = getErrorMessage('Free spin bet');
	} else if (isNaN(+form.free_spin_bet_value)) {
		errors.free_spin_bet_value = 'Free spin bet must be a number';
	}

	if (!form.free_spin_currency) {
		errors.free_spin_currency = getErrorMessage('Free spin currency');
	}

	if (!form.from_spin_expiry) {
		errors.from_spin_expiry = getErrorMessage('Free spin expiry');
	}

	if (!form.provider_id || (Array.isArray(form.provider_id) && form.provider_id.length === 0)) {
		errors.provider_id = getErrorMessage('Provider');
	}

	if (!form.all_games && (!form.games || form.games.length === 0)) {
		errors.games = getErrorMessage('Games');
	}

	return !isEmpty(errors) ? errors : null;
};
